import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

export const CardAnchorLink = ({ label, icon, iconClass, classes, onClick }) => {
  return (
    <Button variant="text" color="secondary" className={classes.orangeLink} onClick={onClick}>
      <span className={classes.linkContent}>
        {label}
        <img src={icon} alt="right arrow" className={iconClass || classes.linkIcon} />
      </span>
    </Button>
  );
};

CardAnchorLink.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};
